// Checkout's saved-address radio list: picking a saved address hides the
// manual entry fields, picking "Use a new address" reveals them. Mirrors the
// same show/hide idea as checkout_toggle.js's "same as billing" checkbox.

document.addEventListener('change', function (event) {
  var radio = event.target.closest('[data-address-picker]')
  if (!radio) return

  var picker = radio.closest('.js-address-picker')
  var target = picker && document.getElementById(picker.dataset.target)
  if (!target) return

  target.hidden = radio.dataset.addressPicker !== 'new'
})
